import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Card, CardContent, CardActions, Button } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FolderIcon from '@mui/icons-material/Folder';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import OutstandingAmount from './OutstandingAmount';
import Ledger from './Ledger';

const vendorDocs = [
  { label: 'GST WTC NEW', file: '/GST WTC NEW.pdf' },
  { label: 'HDFC Bank Mandate', file: '/HDFC Bank mandate_.pdf' },
  { label: 'QCI PAN Card', file: '/QCI PAN CARD.pdf' },
];

const VendorDocs = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h5" sx={{ fontWeight: 700, color: '#00024c', mb: 3 }}>
      Vendor Registration Documents
    </Typography>
    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
      {vendorDocs.map((doc) => (
        <Card key={doc.file} elevation={2} sx={{ width: 260, borderTop: '4px solid #00024c' }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, pb: 1 }}>
            <PictureAsPdfIcon sx={{ fontSize: 56, color: '#d32f2f' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, textAlign: 'center', color: '#00024c' }}>
              {doc.label}
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<OpenInNewIcon />}
              onClick={() => window.open(process.env.PUBLIC_URL + doc.file, '_blank')}
              sx={{ bgcolor: '#00024c', '&:hover': { bgcolor: '#000380' }, textTransform: 'none' }}
            >
              View Document
            </Button>
          </CardActions>
        </Card>
      ))}
    </Box>
  </Box>
);

const OutstandingLedger = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, pt: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{
            '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', fontSize: '0.95rem' },
            '& .Mui-selected': { color: '#00024c' },
            '& .MuiTabs-indicator': { backgroundColor: '#00024c' },
          }}
        >
          <Tab icon={<AccountBalanceWalletIcon />} iconPosition="start" label="Outstanding Amount" />
          <Tab icon={<ReceiptIcon />} iconPosition="start" label="Ledger" />
          <Tab icon={<FolderIcon />} iconPosition="start" label="Vendor Registration Document" />
        </Tabs>
      </Box>
      {tab === 0 && <OutstandingAmount />}
      {tab === 1 && <Ledger />}
      {tab === 2 && <VendorDocs />}
    </Box>
  );
};

export default OutstandingLedger;